class GameData {
  constructor() {
    this.currentRound = 1;
    this.roundReached = 1;
    this.lastRoundUnlocked = 1;
    this.roundResults = [0,0,0,0,0];
    this.dropData = { score: 0, correct: 0, incorrect: 0 };

    this.showedHelped = true;
    this.playedRoundInstructions = false;
  }

  /**
   * @returns {{ answer: any, num1: number, num2: number, incorrects: number }[]}
   */
  getCurrentResults () {
    return this.roundResults[this.currentRound - 1];
  }

  levelUp () {
    this.currentRound++;
    this.roundReached = this.currentRound;
  }
}

const staticGameData = new GameData();

export default staticGameData;

